module.exports = __webpack_public_path__ + "media/images/pic/brodno/cambridge-logo-e20d93d8bdd6c1f94ec5a213cecf3304.svg";